import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { apiPublic } from "@/lib/api";
import { Check, Clock } from "lucide-react";

export default function PaySuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "polling" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    let n = 0;
    async function poll() {
      if (cancelled || n >= 8) return;
      n += 1;
      setAttempts(n);
      try {
        const r = await apiPublic.get(`/payments/status/${sid}`);
        setStatus(r.data);
        if (r.data.payment_status === "paid" || r.data.status === "expired") return;
      } catch (e) { /* keep polling */ }
      setTimeout(poll, 2000);
    }
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  const paid = status.payment_status === "paid";
  return (
    <div className="min-h-screen bg-cream grid place-items-center px-5">
      <div className="bg-white border border-border/60 rounded-2xl p-10 max-w-md w-full text-center">
        <div className={`w-16 h-16 rounded-full grid place-items-center mx-auto ${paid ? "bg-blue-50 text-blue-brand" : "bg-orange-50 text-orange-brand"}`}>
          {paid ? <Check className="w-8 h-8" /> : <Clock className="w-8 h-8" />}
        </div>
        <h1 className="display text-2xl font-semibold mt-6">{paid ? "Payment received!" : "Confirming…"}</h1>
        <p className="text-muted-foreground text-sm mt-2">{paid ? "Thanks. We'll email you a receipt shortly." : `Checking with Stripe (attempt ${attempts})…`}</p>
        <Link to="/" className="inline-block mt-6 text-blue-brand hover:underline">Back to home</Link>
      </div>
    </div>
  );
}
